import { Colors, IconName, Classes, Icon } from "@blueprintjs/core";
import { quarks, Box } from "ui-components";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { ReactNode, useState } from "react";

import { formatLocation } from "../routes";

type LinkT = {
  id: string;
  title: string;
  icon: IconName;
  url: string;
  envs?: string[];
};

const ConfigurationLayout = ({ children }: { children: ReactNode }) => {
  /** Webpack does not allow us to have these links out of the component*/
  const [subRouteLinks] = useState<LinkT[]>([
    {
      id: "create",
      title: "Create",
      icon: "add",
      url: formatLocation.configurationCreate({}),
    },
    {
      id: "upload",
      title: "Upload",
      icon: "upload",
      url: formatLocation.configurationUpload({}),
    },
  ]);

  return (
    <>
      <SubRouteBar>
        {subRouteLinks.map((link) => {
          const { id, url, icon, title } = link;
          return (
            <NavLink
              key={id}
              to={url}
              className={({ isActive }) =>
                `${Classes.BUTTON} ${Classes.MINIMAL}${isActive ? ` ${Classes.INTENT_PRIMARY}` : ""}`
              }
            >
              <Box flexDir="row" items="center">
                <Icon
                  icon={icon}
                  style={{ marginRight: quarks.margins.small }}
                  iconSize={14}
                />
                <span>{title}</span>
              </Box>
            </NavLink>
          );
        })}
      </SubRouteBar>
      <ConfigurationPageWrapper>{children}</ConfigurationPageWrapper>
    </>
  );
};

const ConfigurationPageWrapper = styled.div`
  height: 100%;
  padding-top: 50px;
`;

const SubRouteBar = styled.div`
  height: 50px;
  position: fixed;
  top: 50px;
  margin: 0 -40px;
  padding: 8px 30px;
  width: 100%;
  background-color: ${(props) => {
    return props.theme.darkMode ? Colors.DARK_GRAY2 : Colors.LIGHT_GRAY5;
  }};
  border-top: 1px solid
    ${(props) => {
      return props.theme.darkMode ? Colors.DARK_GRAY4 : Colors.LIGHT_GRAY4;
    }};
  border-bottom: 1px solid
    ${(props) => {
      return props.theme.darkMode ? Colors.DARK_GRAY4 : Colors.LIGHT_GRAY4;
    }};
  /** Without this property all <Select /> elements are placed above the bar. */
  z-index: 15;
`;

export default ConfigurationLayout;
